/**
 * @generated SignedSource<<ec7c640dfd4f64c659f7f8af474a0653>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientEventSignUpAccess = "ALREADY_IN_SERIES" | "CLOSED" | "COMPLETE" | "DRAFT" | "FULL" | "PENDING" | "SIGNUP_AVAILABLE" | "UNAVAILABLE" | "WAITLIST_AVAILABLE";
export type ClientEventSignUpStatus = "CHECKED_IN" | "CONFIRMED" | "NONE" | "WAITLIST";
export type AddEventSignUpToConfirmedInput = {
  eventId: string;
  eventSignUp: CreateEventSignUpInput;
  notifyMember?: boolean | null | undefined;
};
export type CreateEventSignUpInput = {
  customerRegistrations?: ReadonlyArray<CustomerRegistrationInput | null | undefined> | null | undefined;
  guestRegistrations?: ReadonlyArray<GuestRegistrationInput | null | undefined> | null | undefined;
  isDraft?: boolean | null | undefined;
  memberRegistrations?: ReadonlyArray<MemberRegistrationInput | null | undefined> | null | undefined;
  newCustomerRegistrations?: ReadonlyArray<NewCustomerRegistrationInput | null | undefined> | null | undefined;
  newGuestRegistrations?: ReadonlyArray<NewGuestRegistrationInput | null | undefined> | null | undefined;
  ownerClientId?: string | null | undefined;
  paymentCardOnFileId?: string | null | undefined;
};
export type MemberRegistrationInput = {
  formResponses?: ReadonlyArray<EventFormResponseInput | null | undefined> | null | undefined;
  id?: string | null | undefined;
  index: number;
  payingMemberId: string;
  playerId?: string | null | undefined;
  primaryRegistrationChargeTypeId?: string | null | undefined;
};
export type EventFormResponseInput = {
  booleanValue?: boolean | null | undefined;
  eventRegistrationId?: string | null | undefined;
  questionConfigurationId: string;
  stringValue?: string | null | undefined;
  transportationTypeId?: string | null | undefined;
};
export type CustomerRegistrationInput = {
  formResponses?: ReadonlyArray<EventFormResponseInput | null | undefined> | null | undefined;
  id?: string | null | undefined;
  index: number;
  payingCustomerId?: string | null | undefined;
  playerId?: string | null | undefined;
  primaryRegistrationChargeTypeId?: string | null | undefined;
};
export type GuestRegistrationInput = {
  formResponses?: ReadonlyArray<EventFormResponseInput | null | undefined> | null | undefined;
  id?: string | null | undefined;
  index: number;
  payingMemberId: string;
  playerId?: string | null | undefined;
  primaryRegistrationChargeTypeId?: string | null | undefined;
};
export type NewGuestRegistrationInput = {
  email?: string | null | undefined;
  formResponses?: ReadonlyArray<EventFormResponseInput | null | undefined> | null | undefined;
  index: number;
  name: string;
  payingMemberId: string;
  playerId?: string | null | undefined;
  primaryRegistrationChargeTypeId?: string | null | undefined;
};
export type NewCustomerRegistrationInput = {
  email?: string | null | undefined;
  firstName: string;
  formResponses?: ReadonlyArray<EventFormResponseInput | null | undefined> | null | undefined;
  index: number;
  lastName: string;
  payingCustomerId?: string | null | undefined;
  phoneNumber?: string | null | undefined;
  primaryRegistrationChargeTypeId?: string | null | undefined;
};
export type useAddEventSignUpToConfirmedMutation$variables = {
  input: AddEventSignUpToConfirmedInput;
  memberId: string;
};
export type useAddEventSignUpToConfirmedMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly event: {
      readonly eventSeries: {
        readonly events: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly accessStatusForClient: ClientEventSignUpAccess | null | undefined;
              readonly signUpStatusForClient: ClientEventSignUpStatus | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      };
      readonly id: string;
      readonly signUpForClient: {
        readonly id: string;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"EventDetailAttendeesList" | "EventDetailGroupDisplay_event" | "useInitEventSignUps_event">;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useAddEventSignUpToConfirmedMutation = {
  response: useAddEventSignUpToConfirmedMutation$data;
  variables: useAddEventSignUpToConfirmedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "memberId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
],
v8 = {
  "alias": null,
  "args": (v7/*: any*/),
  "kind": "ScalarField",
  "name": "accessStatusForClient",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": (v7/*: any*/),
  "kind": "ScalarField",
  "name": "signUpStatusForClient",
  "storageKey": null
},
v10 = [
  (v6/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "waitlistIndex",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkedIn",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": [
    {
      "alias": "publicId",
      "args": null,
      "kind": "ScalarField",
      "name": "renderingKey",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "payingMember",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unknownRegistrantDisplayName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayDescription",
  "storageKey": null
},
v24 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PhoneNumber",
    "kind": "LinkedField",
    "name": "phoneNumber",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nationalNumber",
        "storageKey": null
      },
      (v6/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "type",
        "value": "GOLF"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "departmentMemberProfiles",
    "plural": true,
    "selections": [
      (v11/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ghinNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Department",
            "kind": "LinkedField",
            "name": "department",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "GolfMemberProfile",
        "abstractKey": null
      },
      (v6/*: any*/)
    ],
    "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
  }
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "EventFormResponseConnection",
  "kind": "LinkedField",
  "name": "formResponses",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventFormResponseEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventFormResponse",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "booleanValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stringValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TransportationType",
              "kind": "LinkedField",
              "name": "transportationType",
              "plural": false,
              "selections": (v10/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FormQuestionConfiguration",
              "kind": "LinkedField",
              "name": "questionConfiguration",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "enabled",
                  "storageKey": null
                },
                (v6/*: any*/),
                (v18/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddEventSignUpToConfirmedMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "AddEventSignUpToConfirmedPayload",
        "kind": "LinkedField",
        "name": "addEventSignUpToConfirmed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EventSeries",
                "kind": "LinkedField",
                "name": "eventSeries",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventConnection",
                    "kind": "LinkedField",
                    "name": "events",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "EventSignUp",
                "kind": "LinkedField",
                "name": "signUpForClient",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventDetailAttendeesList"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useInitEventSignUps_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventDetailGroupDisplay_event"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAddEventSignUpToConfirmedMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "AddEventSignUpToConfirmedPayload",
        "kind": "LinkedField",
        "name": "addEventSignUpToConfirmed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EventSeries",
                "kind": "LinkedField",
                "name": "eventSeries",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventConnection",
                    "kind": "LinkedField",
                    "name": "events",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityCopyOverrides",
                        "kind": "LinkedField",
                        "name": "copyOverrides",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NounOverride",
                            "kind": "LinkedField",
                            "name": "eventPlayer",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "singular",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "supportsPublic",
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "EventSignUp",
                "kind": "LinkedField",
                "name": "signUpForClient",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSignUpWindow",
                    "kind": "LinkedField",
                    "name": "signUpWindow",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cancelDeadlineAt",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canDelete",
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "ownerClient",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": "memberOwnerId",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ],
                        "type": "Member",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ],
                        "type": "Customer",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventRegistrationConnection",
                    "kind": "LinkedField",
                    "name": "registrations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventRegistrationEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v6/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v20/*: any*/)
                                ],
                                "type": "MemberEventRegistration",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v20/*: any*/),
                                  (v21/*: any*/)
                                ],
                                "type": "GuestEventRegistration",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Customer",
                                    "kind": "LinkedField",
                                    "name": "payingCustomer",
                                    "plural": false,
                                    "selections": (v10/*: any*/),
                                    "storageKey": null
                                  },
                                  (v21/*: any*/)
                                ],
                                "type": "CustomerEventRegistration",
                                "abstractKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventRegistrationChargeType",
                                "kind": "LinkedField",
                                "name": "primaryChargeType",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ChargeRuleSet",
                                    "kind": "LinkedField",
                                    "name": "chargeRuleSet",
                                    "plural": false,
                                    "selections": [
                                      (v22/*: any*/),
                                      (v23/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "registrant",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v6/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v17/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v24/*: any*/),
                                    "type": "Member",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v24/*: any*/),
                                    "type": "Customer",
                                    "abstractKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "email",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v25/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "spotsAvailable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "capacityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxGuestCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxMemberCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minMemberCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minGuestCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "capacity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasWaitlist",
                "storageKey": null
              },
              {
                "alias": "eventSignUps",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "waitlist",
                    "value": false
                  }
                ],
                "concreteType": "EventSignUpConnection",
                "kind": "LinkedField",
                "name": "signUps",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSignUpEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSignUp",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventRegistrationConnection",
                            "kind": "LinkedField",
                            "name": "registrations",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "count",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventRegistrationEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v6/*: any*/),
                                      (v18/*: any*/),
                                      (v19/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "registrant",
                                        "plural": false,
                                        "selections": [
                                          (v11/*: any*/),
                                          (v6/*: any*/),
                                          (v14/*: any*/),
                                          (v15/*: any*/),
                                          (v17/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v25/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "signUps(waitlist:false)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memberSignUpProxyAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryChargeType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "EventSignUpWindow",
                "kind": "LinkedField",
                "name": "clientEligibleSignUpWindows",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSignUpWindowChargesConnection",
                    "kind": "LinkedField",
                    "name": "charges",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSignUpWindowChargesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memberControl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventRegistrationChargeType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ChargeRuleSet",
                                "kind": "LinkedField",
                                "name": "chargeRuleSet",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ChargeRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "chargeRules",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ChargeRuleEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ChargeRule",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v6/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "duration",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "price",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "billingId",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "description",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a399c77c983375e6b1c26b1b366399ac",
    "id": null,
    "metadata": {},
    "name": "useAddEventSignUpToConfirmedMutation",
    "operationKind": "mutation",
    "text": "mutation useAddEventSignUpToConfirmedMutation(\n  $input: AddEventSignUpToConfirmedInput!\n  $memberId: ID!\n) {\n  responsePayload: addEventSignUpToConfirmed(input: $input) {\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n    success\n    event {\n      id\n      eventSeries {\n        events {\n          edges {\n            node {\n              accessStatusForClient(clientId: $memberId)\n              signUpStatusForClient(clientId: $memberId)\n              id\n            }\n          }\n        }\n        id\n      }\n      signUpForClient(clientId: $memberId) {\n        id\n      }\n      ...EventDetailAttendeesList\n      ...useInitEventSignUps_event\n      ...EventDetailGroupDisplay_event\n    }\n  }\n}\n\nfragment EventDetailAttendeesGroupListItemFragment on EventSignUp {\n  waitlistIndex\n  id\n  checkedIn\n  registrations {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        formResponses {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                enabled\n                id\n                type\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventDetailAttendeesList on Event {\n  id\n  accessStatusForClient(clientId: $memberId)\n  signUpStatusForClient(clientId: $memberId)\n  spotsAvailable\n  capacityType\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  capacity\n  hasWaitlist\n  eventSeries {\n    facility {\n      copyOverrides {\n        eventPlayer {\n          singular\n        }\n      }\n      id\n    }\n    id\n  }\n  eventSignUps: signUps(waitlist: false) {\n    edges {\n      node {\n        id\n        registrations {\n          count\n        }\n        ...EventDetailAttendeesListItemFragment\n        ...EventDetailAttendeesGroupListItemFragment\n      }\n    }\n  }\n}\n\nfragment EventDetailAttendeesListItemFragment on EventSignUp {\n  waitlistIndex\n  id\n  checkedIn\n  registrations {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        formResponses {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                enabled\n                id\n                type\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventDetailGroupDisplay_event on Event {\n  ...useCurrentSignUp_event\n  id\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  primaryChargeType\n  memberSignUpProxyAllowed\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    charges {\n      edges {\n        memberControl\n        node {\n          id\n          chargeRuleSet {\n            id\n            displayName\n            displayDescription\n            chargeRules {\n              edges {\n                node {\n                  id\n                  duration\n                  price\n                  billingId\n                  description\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment useCurrentSignUp_event on Event {\n  signUpForClient(clientId: $memberId) {\n    signUpWindow {\n      cancelDeadlineAt\n      id\n    }\n    waitlistIndex\n    id\n    canDelete\n    checkedIn\n    ownerClient {\n      __typename\n      ... on Member {\n        id\n        memberOwnerId: id\n        firstName\n        lastName\n        fullName\n        profileImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Customer {\n        id\n        fullName\n        profileImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    registrations {\n      edges {\n        node {\n          __typename\n          id\n          type\n          index\n          ... on MemberEventRegistration {\n            payingMember {\n              id\n            }\n          }\n          ... on GuestEventRegistration {\n            payingMember {\n              id\n            }\n            unknownRegistrantDisplayName\n          }\n          ... on CustomerEventRegistration {\n            payingCustomer {\n              id\n            }\n            unknownRegistrantDisplayName\n          }\n          primaryChargeType {\n            id\n            chargeRuleSet {\n              displayName\n              displayDescription\n              id\n            }\n          }\n          registrant {\n            __typename\n            id\n            firstName\n            lastName\n            profileImage {\n              publicId: renderingKey\n            }\n            ... on Member {\n              phoneNumber {\n                nationalNumber\n                id\n              }\n              departmentMemberProfiles(type: GOLF) {\n                __typename\n                ... on GolfMemberProfile {\n                  ghinNumber\n                  department {\n                    slug\n                    id\n                  }\n                }\n                id\n              }\n            }\n            ... on Customer {\n              phoneNumber {\n                nationalNumber\n                id\n              }\n              departmentMemberProfiles(type: GOLF) {\n                __typename\n                ... on GolfMemberProfile {\n                  ghinNumber\n                  department {\n                    slug\n                    id\n                  }\n                }\n                id\n              }\n            }\n            email\n          }\n          formResponses {\n            edges {\n              node {\n                id\n                booleanValue\n                stringValue\n                transportationType {\n                  id\n                }\n                questionConfiguration {\n                  enabled\n                  id\n                  type\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useInitEventSignUps_event on Event {\n  memberSignUpProxyAllowed\n  ...useCurrentSignUp_event\n  signUpStatusForClient(clientId: $memberId)\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9ab24536c7ce3453eb0716a4e2a5b7e8";

export default node;
